<template>
  <div id="slider-container" class="bg-white slider-container">

    <div class="card-body">
    <validation-errors ref="validationErrors"></validation-errors>
      <div class="homepage-wrap" v-if="!showSlider">
        <div class="w-100 mb-5">
            <h1 class="h3 position-relative z-10 text-black mt-2 mx-3 peak-sans-black text-center">GET YOUR PARAMOUNT+ WITH SHOWTIME REBATE</h1>
            <p class="card-title lead pt-3 px-2 mb-0 w-100 text-center peak-sans">
                Qualifying Paramount+ with SHOWTIME subscribers are eligible to receive a rebate after required months of paid service.
                Click here for <span class="btn-link" style="cursor:pointer;" @click="goModal('provider')">participating providers</span>.<br>
            </p>
            <!-- <h1 class="mb-0 pt-3 text-center text-info w-100">
                COMING SOON!
            </h1> -->
        </div>
        <div class="px-5 row mb-5">
          <button @click="goRebate" class="border btn col-12 col-sm-5 mx-auto px-5 pb-3 text-white bg-red peak-sans" style="font-size: 1.1em; max-width: 300px; padding-top: 20px;">GET YOUR REBATE</button>
          <button @click="goModal('rebate')" class="border btn btn-link col-12 col-sm-5 mt-3 mt-sm-0 mx-auto text-red peak-sans" style="max-width: 300px;">Already Submitted a Rebate?<br>Check Your Status</button>
        </div>
        <p class="card-title lead pt-3 mb-0 w-100 text-center peak-sans ">
                Don’t have Paramount+ with SHOWTIME? <a href='https://sho.com/order' target="_blank" class="cursor">Order Here</a>.
            </p>
      </div>
        <rebate-slider ref="rebateSlider" v-else></rebate-slider>
    </div>
  </div>
</template>

<script>

    import RebateSlider from './RebateSlider.vue';
    export default {
        name:"Homepage",
        mounted() {
            console.log('Component mounted.')
        },

        methods: {
           goModal(modal){
               modal === 'rebate' ?  $('#rebateModal').modal('show') : $('#providerModal').modal('show')
           },
           goRebate(){
               this.$store.commit('SET_SHOWSLIDER');

           }
          },
          computed:{
           showSlider(){
               return this.$store.state.showSlider;
           }
          },
          components: {
              RebateSlider
          }
    }
</script>
<style>
.VueCarousel-inner{
  flex-basis:100% !important;
}
</style>
